import React from 'react';
import { AlertCircle, Clock, TrendingDown } from 'lucide-react';

const ProblemSection = () => {
  const problems = [
    {
      icon: <AlertCircle className="w-8 h-8 text-red-500" />,
      title: "Manual Report Generation",
      description: "Hours spent pulling reports, tweaking data, and manual entry work that could be automated"
    },
    {
      icon: <Clock className="w-8 h-8 text-red-500" />,
      title: "Slow Billing Process",
      description: "Delayed billing cycles and time-consuming report generation that impacts cash flow"
    },
    {
      icon: <TrendingDown className="w-8 h-8 text-red-500" />,
      title: "Limited Analytics",
      description: "Lack of real-time insights and flexible reporting to make informed business decisions"
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Still Struggling with Practice CS Limitations?
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            While Practice CS is powerful, many firms face common challenges that slow down operations and limit growth.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {problems.map((problem, index) => (
            <div key={index} className="text-center p-6 sm:p-8 bg-gray-50 rounded-xl border border-gray-100">
              <div className="flex justify-center mb-4 sm:mb-6">
                {problem.icon}
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                {problem.title}
              </h3>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <div className="inline-flex items-center px-4 sm:px-6 py-3 bg-orange-50 text-orange-700 rounded-full border border-orange-200 text-base sm:text-lg">
            <span className="font-medium">👇 See how we fix these issues below</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;